import React from 'react';

import { SubscriberCouncilPartner } from '../../utils/backend-api/partners';
import SubscriberCouncilCard from './SubscriberCouncilCard';

const SubscriberCouncilContainer = ({ scPartners }: { scPartners: SubscriberCouncilPartner[] }) => {
  return (
    <>
      <div className="flex justify-between items-center w-full px-20 sm:p-0">
        <h3 className="mr-20 text-primary-red font-black text-[18px] font-['Meta',Georgia,sans-serif] whitespace-nowrap">
          <span className="hidden sm:inline">The Information </span>Subscriber Council
        </h3>
        <div className="bg-pro-red w-full h-2"></div>
      </div>
      <div className="mt-0 mb-40 px-20 sm:mt-12 sm:mb-48 sm:p-0 sm:grid sm:grid-cols-2">
        {scPartners.map((partner) => (
          <SubscriberCouncilCard key={`sc-card-${partner.id}`} partner={partner} />
        ))}
        <a
          className="text-[14px] font-['Meta',Georgia,sans-serif] underline pl-12 py-3 border-0 border-l border-[#c4c6ce] border-solid"
          href="/partners#partnerships"
        >
          Learn More
        </a>
      </div>
    </>
  );
};

export default SubscriberCouncilContainer;
